import React from "react";
import { connect } from "react-redux";

import MobileFormViewer from "modules/5_view_helpers/web/FormBuilder/MobileFormViewer";
import { Block, Button } from "framework7-react";
import { getColsAttributes, getActiveHoldPoints } from "modules/5_view_helpers/web/FormBuilder/shared";

function mapStateToProps(state) {
  return {
    projects: state.projects,
    employees: state.employees,
    custom_forms: state.custom_forms,
    custom_form_records: state.custom_form_records,
    react_dropzone_status: state.react_dropzone_status,
  };
}

const CustomFormRecordForm = (props) => {
  const { handleSubmit, formLabel, cancelFunction, custom_form, outlookMode, parents, parentSelectLabel, edit, submitForm } = props;
  const stillUploading = props.react_dropzone_status > 0;
  const cols = getColsAttributes(custom_form);
  const activeHoldPoints = getActiveHoldPoints(cols, props.values);

  const saveAsDraft = () => {
    submitForm({ ...props.values, draft: true });
  };

  return (
    <MobileFormViewer
      custom_form={custom_form}
      cancelFunction={cancelFunction}
      formLabel={formLabel}
      handleSubmit={handleSubmit}
      outlookMode={outlookMode} // Outlook Mode
      parents={parents} // Passing parents to form viewer for the outlook mode only.
      parentSelectLabel={parentSelectLabel}
      edit={edit}
      disabled={stillUploading}
      disabledMessage="File/s still uploading. Please wait."
      {...props}
    >
      <hr />
      <Block>
        <Button
          onClick={saveAsDraft}
          className="mr-2"
          disabled={stillUploading}
          color={_.isNotEmpty(activeHoldPoints) ? "orange" : "gray"}
          fill
        >
          Save as Draft
        </Button>
        <Button className="margin-top" fill onClick={cancelFunction} color="danger">
          Cancel
        </Button>
      </Block>
    </MobileFormViewer>
  );
};

export default connect(mapStateToProps, {})(CustomFormRecordForm);
